module.exports = __webpack_public_path__ + "static/media/icon-change-meal.59f9c9e5.svg";